module.exports = __webpack_public_path__ + "static/img/store-icon10.a6432cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon10.png
// module id = 8HAK
// module chunks = 1